/**
 *
 */
export const OBJECT_START_UPLOAD = 'OBJECT_START_UPLOAD';
/**
 *
 */
export const OBJECT_UPLOAD_PROGRESS = 'OBJECT_UPLOAD_PROGRESS';
/**
 *
 */
export const OBJECT_FINISHED_UPLOAD = 'OBJECT_FINISHED_UPLOAD';
/**
 *
 */
export const OBJECT_UPLOAD_ERROR = 'OBJECT_UPLOAD_ERROR';

/**
 * when a user closes or dismisses the upload progress of something (after it's done)
 */
export const OBJECT_CLOSE_PROGRESS = 'OBJECT_CLOSE_PROGRESS';

/**
 *
 */
export const OBJECT_START_DOWNLOAD = 'OBJECT_START_DOWNLOAD';
/**
 *
 */
export const OBJECT_DOWNLOAD_PROGRESS = 'OBJECT_DOWNLOAD_PROGRESS';
/**
 *
 */
export const OBJECT_FINISHED_DOWNLOAD = 'OBJECT_FINISHED_DOWNLOAD';
/**
 *
 */
export const OBJECT_DOWNLOAD_ERROR = 'OBJECT_DOWNLOAD_ERROR';
